/**
 * A prompt waiting for the GAIA column, written by the GAIA beat. State
 * rather than an event, so the column picks it up whenever it mounts. The
 * contract for the GAIA port: when `prompt` is not null, put it in the input
 * (do not send it) and call take() to clear it. Nothing reads it until the
 * GAIA column does; see PORT_NOTES.md.
 */
import { create } from 'zustand';

interface GaiaPrefillState {
  prompt: string | null;
  /** Bumped on every request, so the same prompt twice still reads as new. */
  seq: number;
  request: (prompt: string) => void;
  /** Returns the waiting prompt and clears it. */
  take: () => string | null;
}

export const useGaiaPrefill = create<GaiaPrefillState>()((set, get) => ({
  prompt: null,
  seq: 0,
  request: (prompt) => set((s) => ({ prompt, seq: s.seq + 1 })),
  take: () => {
    const { prompt } = get();
    if (prompt !== null) set({ prompt: null });
    return prompt;
  },
}));

export function requestGaiaPrefill(prompt: string): void {
  useGaiaPrefill.getState().request(prompt);
}
